export const tests = [
  { id: 1, name: 'Overall' },
  { id: 2, name: 'Kids Starter' },
  { id: 3, name: 'EOC Lite Juniors 1' },
]

export const categories = [
  { id: 1, name: 'Unit test' },
  { id: 2, name: 'MT Kids 1' },
  { id: 3, name: 'MT Kids 2 Starters' },
  { id: 4, name: 'MT Kids 3' },
  { id: 5, name: 'MT Kids 4 Movers' },
  { id: 6, name: 'MT Kids 5' },
  { id: 7, name: 'MT Kids 6 Flyers' },
  { id: 8, name: 'MT Juniors 1 Starters' },
  { id: 9, name: 'MT Juniors 2 Movers' },
  { id: 10, name: 'MT Juniors 3 Flyers' },
  { id: 11, name: 'MT Juniors 4 Flyers' },
  { id: 12, name: 'MT Juniors 5 KETfs' },
  { id: 13, name: 'MT Teens 1' },
  { id: 14, name: 'MT Teens 2 KET' },
  { id: 15, name: 'MT Teens 3 PET' },
  { id: 16, name: 'MT Teens 4 PET' },
  { id: 17, name: 'MT Teens 4+ PET' },
  { id: 18, name: 'MT Young Adults 1' },
  { id: 19, name: 'MT Young Adults 2 KET' },
  { id: 20, name: 'MT Young Adults 3 PET' },
  { id: 21, name: 'MT Young Adults 4 FCE' },
  { id: 22, name: 'MT Young Adults 5 CAE' },
  { id: 23, name: 'MT Adults 1' },
  { id: 24, name: 'MT Adults 2 KET' },
  { id: 25, name: 'MT Adults 3 PET' },
  { id: 26, name: 'MT Adults 4 FCE' },
  { id: 27, name: 'MT Adults 5 CAE' },
  { id: 28, name: 'EOC Kids Starter' },
  { id: 29, name: 'EOC Juniors Starter' },
  { id: 30, name: 'EOC Teens and Young Adults Starter' },
  { id: 31, name: 'EOC Adults Starter' },
  { id: 32, name: 'EOC Kids 1' },
  { id: 33, name: 'EOC Kids 2 Starters' },
  { id: 34, name: 'EOC Kids 3' },
  { id: 35, name: 'EOC Kids 4 Movers' },
  { id: 36, name: 'EOC Kids 5' },
  { id: 37, name: 'EOC Kids 6 Flyers' },
  { id: 38, name: 'EOC Juniors 1 Starters' },
  { id: 39, name: 'EOC Juniors 2 Movers' },
  { id: 40, name: 'EOC Juniors 3 Flyers' },
  { id: 41, name: 'EOC Juniors 4 Flyers' },
  { id: 42, name: 'EOC Juniors 5 KETfs' },
  { id: 43, name: 'EOC Teens 1' },
  { id: 44, name: 'EOC Teens 2 KET' },
  { id: 45, name: 'EOC Teens 3 PET' },
  { id: 46, name: 'EOC Teens 4 PET' },
  { id: 47, name: 'EOC Teens 4+ PET' },
  { id: 48, name: 'EOC Young Adults 1' },
  { id: 49, name: 'EOC Young Adults 2 KET' },
  { id: 50, name: 'EOC Young Adults 3 PET' },
  { id: 51, name: 'EOC Young Adults 4 FCE' },
  { id: 52, name: 'EOC Young Adults 5 CAE' },
  { id: 53, name: 'EOC Adults 1' },
  { id: 54, name: 'EOC Adults 2 KET' },
  { id: 55, name: 'EOC Adults 3 PET' },
  { id: 56, name: 'EOC Adults 4 FCE' },
  { id: 57, name: 'EOC Adults 5 CAE' },
  { id: 58, name: 'Early Warning' },
  { id: 59, name: 'Level Check' },
]
